"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useZNFT = void 0;

var tslib_1 = require("tslib");

var react_1 = require("react");

var swr_1 = tslib_1.__importDefault(require("swr"));

var NFTFetchContext_1 = require("../context/NFTFetchContext");

var TransformFetchResults_1 = require("../fetcher/TransformFetchResults");

var ExtractResultData_1 = require("../fetcher/ExtractResultData");
/**
 * Fetches on-chain NFT data and pricing for the given zNFT id
 * Deprecated: Please use useNFT instead.
 *
 * @param id id of zNFT to fetch blockchain information for
 * @param options SWR flags and an option to load currency info
 * @returns useNFTType hook results include loading, error, and chainNFT data.
 */


function useZNFT(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fetcher = react_1.useContext(NFTFetchContext_1.NFTFetchContext);

  var _ref = options || {},
      _ref$loadCurrencyInfo = _ref.loadCurrencyInfo,
      loadCurrencyInfo = _ref$loadCurrencyInfo === void 0 ? false : _ref$loadCurrencyInfo,
      refreshInterval = _ref.refreshInterval,
      initialData = _ref.initialData;

  var nftData = swr_1.default(id ? ['loadZNFTDataUntransformed', id] : null, function (_, id) {
    return fetcher.loadZNFTDataUntransformed(id);
  }, {
    refreshInterval: refreshInterval,
    dedupingInterval: 0
  });
  var currencyData = swr_1.default(nftData.data && nftData.data.pricing && loadCurrencyInfo ? ['loadCurrencies'].concat(_toConsumableArray(ExtractResultData_1.getCurrenciesInUse(TransformFetchResults_1.addAuctionInformation(nftData.data.pricing)))) : null, function (_) {
    for (var _len = arguments.length, currencies = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      currencies[_key - 1] = arguments[_key];
    }

    return fetcher.loadCurrencies(currencies);
  }, {
    refreshInterval: refreshInterval,
    dedupingInterval: 0
  });
  var data;

  if (nftData.data !== undefined) {
    data = _objectSpread(_objectSpread({}, nftData.data), {}, {
      pricing: TransformFetchResults_1.addAuctionInformation(nftData.data.pricing, currencyData.data)
    });
  } else {
    data = initialData;
  }

  return {
    currencyLoaded: !!currencyData.data,
    error: nftData.error,
    data: data
  };
}

exports.useZNFT = useZNFT;